import { render } from "./assist.vue?vue&type=template&id=a4fb33a6&scoped=true"
import script from "./assist.vue?vue&type=script&lang=js"
export * from "./assist.vue?vue&type=script&lang=js"

import "./assist.vue?vue&type=style&index=0&id=a4fb33a6&lang=scss&scoped=true"

import exportComponent from "D:\\codes\\chat28\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4fb33a6"]])

export default __exports__